
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../../common/client/sagas/common';

import server from '../server';

export const DATA_DOCUMENT_ACTION_TYPE = createActionTypes('data/DOCUMENT');
export const ADD_DOCUMENT_FOR_OBJECT = 'data/document/ADD_DOCUMENTS_FOR_OBJECT';
export const CLEAR = 'data/document/CLEAR';
export const DELETE_DOCUMENT = 'data/document/DELETE';
export const GET_DOCUMENT = 'data/document/GET';
export const INSERT_DOCUMENT = 'data/document/INSERT';
export const INSERT_DOCUMENT_TO_OBJECTS = 'data/document/INSERT_TO_OBJECTS';
export const REMOVE_DOCUMENT_FOR_OBJECT = 'data/document/REMOVE_DOCUMENT_FOR_OBJECT';
export const SET_DOCUMENTS_FOR_OBJECT = 'data/document/SET_DOCUMENTS_FOR_OBJECT';
export const UPDATE_DOCUMENT = 'data/document/UPDATE';
export const UPDATE_DOCUMENT_FOR_OBJECT = 'data/document/UPDATE_DOCUMENT_FOR_OBJECT';

export default function getActions(dispatch) {
    return {
        clear: () => dispatch({
            type: CLEAR
        }),
        deleteDocument: (token, projectId, params) => dispatch({
            type: DELETE_DOCUMENT,
            token, projectId, params,
            operation: 'delete'
        }),
        getDocumentList: (token, projectId, objectKey) => dispatch({
            type: GET_DOCUMENT,
            token, projectId, objectKey,
            operation: 'get'
        }),
        insertDocument: (token, projectId, params) => dispatch({
            type: INSERT_DOCUMENT,
            token, projectId, params,
            operation: 'insert'
        }),
        insertDocumentToObjects: (token, projectId, params) => dispatch({
            type: INSERT_DOCUMENT_TO_OBJECTS,
            token, projectId, params,
            operation: 'insertToObjects'
        }),
        updateDocument: (token, projectId, params) => dispatch({
            type: UPDATE_DOCUMENT,
            token, projectId, params,
            operation: 'update'
        }),
    };
}

function* afterSuccessDelete(action, result) {
    yield put({type: REMOVE_DOCUMENT_FOR_OBJECT, document: result.document});
}

function* afterSuccessGet(action, result) {
    yield put({type: SET_DOCUMENTS_FOR_OBJECT, objectKey: action.objectKey, documents: result.documents});
}

function* afterSuccessInsert(action, result) {
    yield put({type: ADD_DOCUMENT_FOR_OBJECT, document: result.document});
}

function* afterSuccessInsertToObjects(action, result) {
    yield put({type: CLEAR});
}

function* afterSuccessUpdate(action, result) {
    yield put({type: UPDATE_DOCUMENT_FOR_OBJECT, document: result.document});
}

function execOperation(action) {
    return new Promise((resolve, reject) => {
        server.data.execDocument(
            action.token, action.projectId, action.operation,
            action.objectKey, action.params, action.clientOptions, action.debug,
            (err, result) => {
                if (result) {
                    resolve(result);
                } else {
                    reject(err);
                }
            }
        );
    });
}

function* workExecOperation(options, funcCallApi, funcSuccess, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: DATA_DOCUMENT_ACTION_TYPE.LOADING});
        const result = yield call(funcCallApi, action);
        yield put({type: DATA_DOCUMENT_ACTION_TYPE.SUCCESS, result});
        if (result.success) {
            yield call(funcSuccess, action, result);
        }
        yield call(checkOperationResult, result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, DATA_DOCUMENT_ACTION_TYPE);
    }
}

export function* watchDeleteDocument(options) {
    yield takeEvery(
        DELETE_DOCUMENT, workExecOperation, options,
        execOperation, afterSuccessDelete, 'Smazání odkazu na dokument'
    );
}

export function* watchGetDocument(options) {
    yield takeEvery(
        GET_DOCUMENT, workExecOperation, options,
        execOperation, afterSuccessGet, 'Načtení odkazů na dokumenty'
    );
}
export function* watchInsertDocument(options) {

    yield takeEvery(
        INSERT_DOCUMENT, workExecOperation, options,
        execOperation, afterSuccessInsert, 'Připojení nového odkazu na dokument'
    );
}

export function* watchInsertDocumentToObjects(options) {

    yield takeEvery(
        INSERT_DOCUMENT_TO_OBJECTS, workExecOperation, options,
        execOperation, afterSuccessInsertToObjects, 'Připojení nového odkazu na dokument'
    );
}

export function* watchUpdateDocument(options) {
    yield takeEvery(
        UPDATE_DOCUMENT, workExecOperation, options,
        execOperation, afterSuccessUpdate, 'Uložení změn existujícího odkazu na dokument'
    );
}
